export class Center {

    public relations = [];

    public profile_fields = [];


    public names = {
        // therapist__user_id: function (data) {
        //     if(!data.therapist){
        //         return 'нет';
        //     }
        //     return data.therapist.f + ' ' + data.therapist.i + ' '  + data.therapist.o;
        // },
        //
        // patient__user_id: function (data) {
        //     if(!data.patient){
        //         return 'нет';
        //     }
        //     return data.patient.f + ' ' + data.patient.i + ' '  + data.patient.o;
        // },
        //
        // therapist_schedule_id: function (data) {
        //     if(!data.therapist_schedule){
        //         return 'нет';
        //     }
        //     return data.therapist_schedule.date_time;
        // },
    }
}
